import React from "react"
import { Link } from "react-router-dom"
import Footer from "../../containers/Footer"
import LSHeader from "../../containers/LSHeader"

function RegisterIntro(){
    return(
        <>
        <LSHeader/>
        <div className="container">
        <div className="login-media align-items-stretch justify-content-center ht-100p">
        <a href="https://partner.goalstox.com/" className="btn btn-success" >Register as Partner</a>
        <Link to="/registerascustomer" className="btn btn-success" >Register as Customer</Link>
        </div>
        </div>

        <Footer/>
        </>
    )
}
export default RegisterIntro